import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../api";
import StudentView from "../components/StudentView";

export default function StudentDashboard() {
  const [student, setStudent] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api
      .get("/students/me/self")
      .then(({ data }) => setStudent(data))
      .catch((ex) => setErr(formatApiError(ex)));
  }, []);

  if (err) return <div className="text-[#9B2C3B] text-[13px]">{err}</div>;
  if (!student) return <div className="text-[13px] text-[#132C44]/60">Cargando…</div>;

  return (
    <div className="space-y-6">
      <div>
        <span className="inline-block text-[10px] font-semibold tracking-widest text-[#4F6B47] px-2 py-1 border border-[#4F6B47]/30 rounded-full">
          MI ENGLISH ID
        </span>
        <h1 className="mt-4 font-serif text-3xl sm:text-4xl font-bold" data-testid="eid-student-greeting">
          Hola, {student.firstName}.
        </h1>
        <p className="mt-1 text-[13px] text-[#132C44]/65">
          {student.courseName ? `${student.courseName} · ` : ""}
          {student.level || student.courseLevel || ""}
        </p>
      </div>
      <StudentView student={student} />
    </div>
  );
}
